import PropTypes from 'prop-types';

export const winnerPropType = PropTypes.shape({
  category: PropTypes.string.isRequired,
  profileName: PropTypes.string.isRequired,
  profileUrl: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
});

export const awardGroupPropType = PropTypes.shape({
  name: PropTypes.string,
  winners: PropTypes.arrayOf(winnerPropType),
});

export const risingStarPageContent = PropTypes.shape({
  title: PropTypes.string.isRequired,
  metaDescription: PropTypes.string.isRequired,
  awardGroups: PropTypes.arrayOf(awardGroupPropType),
  publishedYears: PropTypes.arrayOf(PropTypes.number).isRequired,
});
